import React, { useState } from 'react';
import styles from './getStarted.module.scss';
import ReCAPTCHA from 'react-google-recaptcha';
import Button from '../button/Button';
import { setNotARobot } from '../../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const GetStarted = props => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const robotData = useSelector(state => state.robot);
  const [getStarted, setGetStarted] = useState(false);

  const navigateForward = () => {
    window.scrollTo(0, 0);
    history.push('/death-check');
  };

  const logEvent = () => {
    ReactGA.event({
      category: location.pathname,
      action: 'click',
      label: 'Get started',
    });
  };

  return (
    <>
      <div className={styles.upperFooter}>
        <div className={`container`}>
          {!getStarted ? (
            <div className={`row`}>
              <div className={`col-12`}>
                <div className={`row ${styles.buttonCont}`}>
                  <div className={`col-lg-2 col-12 ${styles.leftCont}`}>
                    <Button
                      onClick={() => {
                        logEvent();
                        if (process.env.REACT_APP_CAPTCHA_ENABLED === 'true') {
                          setGetStarted(true);
                        } else {
                          dispatch(setNotARobot(true));
                          navigateForward();
                        }
                      }}
                    >
                      Get started
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {getStarted ? (
            <div>
              <div className={`row`}>
                <div className={`col-12`}>
                  <div className={styles.recaptchaSection}>
                    <label
                      htmlFor={'g-recaptcha-response'}
                      className={styles.hiddenLabelWhite}
                    ></label>
                    <ReCAPTCHA
                      sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                      onChange={value => {
                        dispatch(setNotARobot(value !== null));
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className={`row mt-4`}>
                <div className={`col-12`}>
                  <div className={`row ${styles.buttonCont}`}>
                    <div className={`col-md-2 col-12 ${styles.leftCont}`}>
                      <Button
                        disabled={robotData.notARobot ? false : true}
                        onClick={() => {
                          if (robotData.notARobot) {
                            navigateForward();
                          }
                        }}
                      >
                        Continue
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default GetStarted;
